module.exports = __webpack_public_path__ + "img/paycheque.c301dc2d.svg";